import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import {
  Row,
  Panel,
  IconButton,
  Icon,
  Modal,
  Button,
  Col,
  ControlLabel,
  RadioGroup,
  Radio,
  Message,
  SelectPicker,
  Input,
  Checkbox,
  Uploader,
} from 'rsuite'
import AttachFilesMakeContract from './AttachFilesMakeContract'
import AttachFilesView from './AttachFilesMakeContractView'
import AttachFilesGranteeContract from './AttachFilesGranteeContract'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import EditButton from '../../components/buttons/editButton/EditButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import {
  getDownload,
  getAttachments,
  saveAttachments,
  updateAttachments,
  deleteAttachments,
} from '../../redux/actions/attachments'
import { startLoading, doneLoading } from '../../utils/loading'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
import PdfRenderWidgets from '../pdfWidgets/PdfRenderWidgets'
import { isRequired, isValidators, isRequiredFiled } from '../../utils/ValidatorUtils'
import {
  saveAttachmentGrantee,
  deleteAttachmentGrantee,
  getAttachmentGrantee,
  updateMakeContract,
  getMakeContract,
  getDownloadAttachmentGrantee,
  getContractPdf,
  getDownloadContractPdf,
  getDownloadContractPdfRealtime,
  getDownloadProposalPdfRealtime,
  getAddAttachmentsContractForm,
  saveAddAttachmentsContractAndBankAccount,
  downloadOpenBankAccountFile,
  getBankAccount,
  updateMakeContractChangeWithdrawPerson,
} from '../../redux/actions/contract'
import ConfirmWidget from '../../widgets/confirm/ConfirmWidget'
import pathname from '../../constants/pathname'
import classNames from 'classnames'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import CenterAddBankAccountForm from '../../widgets/contractCenterAddBankAccount/CenterAddBankAccountForm'
import { getAllAttachments } from '../../redux/actions/attachments'
import AttachFilesDocWidget from '../../widgets/attachfiles/AttachFilesDocWidget'
import { API_ROOT } from '../../config/config'
import COIValidateWidget from '../coi/COIValidateWidget'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import InputForm from '../../components/forms/input/InputForm'
import AppContext from '../../context/AppContext'
import { isEmpty } from 'lodash-es'

export default function MakeContractPanel(props) {
  const {
    showCommandButton,
    isEdit,
    onChangeIsEdit,
    isAddAtttachmentsOnly,
    bankAccountSchema,
    requestDocText,
  } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [section, setSection] = useState()
  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [formBankAccountSchema, setFormBankAccountSchema] = useState(bankAccountSchema)
  const [showConfirm, setShowConfirm] = useState(false)
  const [isMakeContractError, setIsMakeContractError] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isContartFileError, setIsContartFileError] = useState(false)
  const [isGranteeFileError, setIsGranteeFileError] = useState(false)
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [signatoryList, setSignatoryList] = useState([])
  const [request, setRequest] = useState()
  const [isOpenBankPdfError, setIsOpenBankPdfError] = useState(false)
  const [previewOpenBankPdf, setPreviewOpenBankPdf] = useState()
  const [isLoadingOpenBankPDF, setIsLoadingOpenBankPDF] = useState()

  const [schemaFileAll, setSchemaFileAll] = useState()
  const [errorSchemaFileAll, setErrorSchemaFileAll] = useState(false)

  const [withdrawAuthorizedRequest, setWithdrawAuthorizedRequest] = useState(1)

  const [isWithdrawFirst, setIsWithdrawFirst] = useState(false)

  const [isCheckCOI, setIsCheckCOI] = useState(false)
  const [isCOIPass, setIsCOIPass] = useState(false)
  const [checkCOI, setCheckCOI] = useState(false)
  const [checkInterest, setCheckInterest] = useState(false)
  const [showCOIDetail, setShowCOIDetail] = useState(false)
  const [isShareholdersCoi, setIsShareholdersCoi] = useState(false)
  
  const [isChangeMainPerson, setIsChangeMainPerson] = useState(false)
  const [showConfirmChangeMainPerson, setShowConfirmChangeMainPerson] = useState(false)

  const { theme } = React.useContext(AppContext)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  useEffect(() => {
    if (formSchema?.withdrawFirstPaidInd) {
      setIsWithdrawFirst(formSchema?.withdrawFirstPaidInd)
    }
  }, [formSchema])

  useEffect(() => {
    if (formSchema?.filepdf?.fileName) {
      !isAddAtttachmentsOnly &&
        !requestDocText &&
        handleGetDownloadContractPdf(formSchema.filepdf.fileName)
    }
  }, [formSchema?.filepdf?.fileName])

  useEffect(() => {
    //hide get pdf open book bank
    //isAddAtttachmentsOnly && projectId && handleGetOpenBankFile(projectId)

    handleGetSchemaFileAll()
  }, [projectId])

  useEffect(() => {
    let arr = props?.schema?.withdrawAuthorized?.values || []
    let isGanteeCompany = props?.schema?.withdrawAuthorized?.granteeCompany
    console.log('arr', arr)
    if (arr.length > 0) {
      let newList = sortByMainPersonFirst(arr)

      if (isGanteeCompany) {
        switch (newList.length) {
          case 1:
            newList.push(
              { honorific: '', firstName: '', lastName: '' },
              { honorific: '', firstName: '', lastName: '' }
            )
            break
          case 2:
            newList.push({ honorific: '', firstName: '', lastName: '' })
            break
          default:
            break
        }
      }
      console.log('newList', newList)
      setSignatoryList(newList)

      newList.forEach((item, index) => {
        setValue(formSchema?.withdrawAuthorized?.honorific?.name + index, item.honorific)
        setValue(formSchema?.withdrawAuthorized?.firstName?.name + index, item.firstName)
        setValue(formSchema?.withdrawAuthorized?.lastName?.name + index, item.lastName)
      })
    } else {
      let initialList = [{ honorific: '', firstName: '', lastName: '' }]
      if (isGanteeCompany) {
        initialList.push(
          { honorific: '', firstName: '', lastName: '' },
          { honorific: '', firstName: '', lastName: '' }
        )
      }

      setSignatoryList(initialList)
    }

    if (isGanteeCompany) {
      setWithdrawAuthorizedRequest(3) //set number of request person e.g. 3 = 3 person (need to set newList and initialList)
    }
  }, [props?.schema?.withdrawAuthorized?.values])

  const sortByMainPersonFirst = (list) => {
    let newList = [...list]
    list.forEach((item, index) => {
      if (item.isMainPerson) {
        newList.splice(index, 1)
        newList.unshift(item)
      }
    })
    return newList
  }

  const handleGetSchemaFileAll = async () => {
    setIsLoading(true)
    startLoading()
    setErrorSchemaFileAll(false)
    try {
      const _schema = await getAllAttachments(projectId)
      setSchemaFileAll(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setErrorSchemaFileAll(e.response.data.errors?.message)
      } else {
        setErrorSchemaFileAll('ไม่สำเร็จ')
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetDownloadContractPdf = async (fileName) => {
    startLoading()
    //setIsLoading(true)
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const response = await getDownloadContractPdf(projectId, fileName)
      console.log('response preview pdf', response)
      if (!response.success) {
        setPreviewPdf(response)
        setIsPdfError(false)
      }
    } catch (e) {
      try {
        const response = await getDownloadContractPdfRealtime(projectId)

        if (!response.success) {
          setPreviewPdf(response)
          setIsPdfError(false)
        } else {
          setIsPdfError(true)
        }
      } catch (error) {
        setIsPdfError(true)
      }
    }
    //setIsLoading(false)
    setIsLoadingPDF(false)
    doneLoading()
  }

  const handleGetOpenBankFile = async (id) => {
    startLoading()
    setIsOpenBankPdfError(false)
    setIsLoadingOpenBankPDF(true)
    try {
      const response = await downloadOpenBankAccountFile(id)
      console.log('response preview pdf', response)
      if (response) {
        setPreviewOpenBankPdf(response)
        setIsOpenBankPdfError(false)
      } else {
        setIsOpenBankPdfError(true)
      }
    } catch (e) {
      setIsOpenBankPdfError(true)
    }
    setIsLoadingOpenBankPDF(false)
    doneLoading()
  }

  const handleUpdateMakeContract = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsMakeContractError(false)
    try {
      console.log('update')
      let response

      isAddAtttachmentsOnly
        ? (response = await saveAddAttachmentsContractAndBankAccount(request, projectId))
        : (response = await updateMakeContract(request, projectId))

      console.log('response', response)

      if (response.success) {
        //success! jump to new page
        setIsMakeContractError(false)
        setIsLoading(false)
        doneLoading()
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setIsMakeContractError(true)
      }
      setShowConfirm(false)
    } catch (e) {
      console.log('e', e.response)
      setIsMakeContractError(true)
      setShowConfirm(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpdateMakeContractAndChangeMainPerson = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsMakeContractError(false)
    try {
      let response = await updateMakeContractChangeWithdrawPerson(request, projectId)

      if (response.success) {
        //success! jump to new page
        setIsMakeContractError(false)
        setIsLoading(false)
        doneLoading()
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setIsMakeContractError(true)
      }
      setShowConfirm(false)
    } catch (e) {
      console.log('e', e.response)
      setIsMakeContractError(true)
      setShowConfirm(false)
    }
    setShowConfirm(false)
    setIsLoading(false)
    doneLoading()
  }

  const handleUpload = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsUploadErr()
    try {
      console.log('upload')
      const response = await saveAttachmentGrantee(request, projectId)
      console.log('response', response)

      if (response) {
        let _response
        isAddAtttachmentsOnly
          ? (_response = await getAddAttachmentsContractForm(projectId))
          : (_response = await getMakeContract(projectId))
        setFormSchema(_response.model.forms.forms)
        setIsUploadErr(false)
      } else {
        setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsUploadErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (id) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError(false)
    try {
      console.log('call delete.')
      const status = await deleteAttachmentGrantee(projectId, id)
      console.log('status', status)
      if (status === 200) {
        let response
        isAddAtttachmentsOnly
          ? (response = await getAddAttachmentsContractForm(projectId))
          : (response = await getMakeContract(projectId))
        setFormSchema(response.model.forms.forms)
        setIsDeleteError(false)
      } else {
        setIsDeleteError(response.model.errorMessage || 'ไม่สำเร็จ')
      }
    } catch (e) {
      console.log('e', e)
      if (e?.response?.data) {
        setIsDeleteError(e.response.data.errorMessage)
      } else {
        setIsDeleteError('ไม่สำเร็จ')
      }
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleOnUploadSuccess = async (res) => {
    startLoading()
    setIsLoading(true)
    setIsGranteeFileError(false)
    try {
      if (res.success) {
        let response
        isAddAtttachmentsOnly
          ? (response = await getAddAttachmentsContractForm(projectId))
          : (response = await getMakeContract(projectId))
        setFormSchema(response.model.forms.forms)
      }
    } catch (e) {
      console.log('e', e)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onDownloadContractAndProposalFile = async (fileObj) => {
    startLoading()
    try {
      var file = await getDownloadContractPdf(projectId, fileObj.name)
      // var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileObj.name)
      document.body.appendChild(link)
      link.click()
      setIsContartFileError()
    } catch (e) {
      try {
        var file
        if (fileObj.name == 'contract') file = await getDownloadContractPdfRealtime(projectId)
        if (fileObj.name == 'proposal') file = await getDownloadProposalPdfRealtime(projectId)

        const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileObj.name)
        document.body.appendChild(link)
        link.click()
        setIsContartFileError()
      } catch (error) {
        setIsContartFileError('ดาวน์โหลด')
      }
    }
    doneLoading()
  }

  const onPreviewContractAndProposalFile = async (fileObj) => {
    startLoading()
    try {
      var file = await getDownloadContractPdf(projectId, fileObj.name)
      // var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.setAttribute('value', fileObj.name)
      document.body.appendChild(link)
      link.click()
      setIsContartFileError()
    } catch (e) {
      try {
        var file
        if (fileObj.name == 'contract') file = await getDownloadContractPdfRealtime(projectId)
        if (fileObj.name == 'proposal') file = await getDownloadProposalPdfRealtime(projectId)

        const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
        const link = document.createElement('a')
        link.href = url
        link.target = '_blank'
        link.setAttribute('value', fileObj.name)
        document.body.appendChild(link)
        link.click()
        setIsContartFileError()
      } catch (error) {
        setIsContartFileError('แสดง')
      }
    }
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await getDownloadAttachmentGrantee(projectId, fileObj.id)
      // var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileObj.name)
      document.body.appendChild(link)
      link.click()
      setIsGranteeFileError()
    } catch (e) {
      setIsGranteeFileError('ดาวน์โหลดไม่สำเร็จ')
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await getDownloadAttachmentGrantee(projectId, fileObj.id)
      // var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.setAttribute('value', fileObj.name)
      document.body.appendChild(link)
      link.click()
      setIsGranteeFileError()
    } catch (e) {
      setIsGranteeFileError('แสดงไม่สำเร็จ')
    }
    doneLoading()
  }

  const onUpload = (data) => {
    console.log('onSubmit data', data)
    const file = data[formSchema.attachmentGrantee.attachFiles.name]
    var formData = new FormData()

    file?.forEach((element) => {
      formData.append('files', element.blobFile)
    })

    formData.append('MasterContractFileId', data.contractFileType || '')
    formData.append('ProjectVersionId', projectId || '')
    //formData.append('Id', contractId || '')
    formData.append('UserId', '')

    handleUpload(formData)
  }

  const onUpdate = (file, newName) => {
    console.log('onUpdate file', file, 'newName: ', newName)

    file['projectVersionId'] = projectId
    file['userId'] = 111
    file.label = newName

    console.log('file', file)
    handleUpdate(file)
  }

  const onDelete = (id) => {
    handleDelete(id)
  }

  const onSubmit = (data) => {
    console.log('data', data)
    console.log('attachFiles => ', formSchema.attachmentGrantee.attachFiles)
    console.log('signatoryList', signatoryList)
    console.log('formBankAccountSchema => ', formBankAccountSchema)

    let withdrawPerson = signatoryList.map((item, index) => {
      item.honorific = data[formSchema?.withdrawAuthorized?.honorific?.name + index]
      item.firstName = data[formSchema?.withdrawAuthorized?.firstName?.name + index]
      item.lastName = data[formSchema?.withdrawAuthorized?.lastName?.name + index]
      if (index === 0) {
        item.isMainPerson = true
      } else {
        item.isMainPerson = false
      }
      return item
    })

    const bankName =
      formBankAccountSchema?.bankName?.options?.find((e) => e.value == data.bankName) || ''
    const bankBranch =
      formBankAccountSchema?.bankBranch?.options?.find((e) => e.value == data.bankBranch) || ''

    console.log('bankName => ', bankName)
    console.log('bankBranch => ', bankBranch)

    let request = {
      // id: contractId,
      bankCode: data?.bankName || '',
      bankName: bankName.label || '',
      bankBranch: bankBranch.label || '',
      bankAccountNumber: data?.bankAccountNumber,
      bankAccountName: data?.bankAccountName || '',
      bankBranchCode: data.bankBranch,
      bankAccountType: data.bankAccountType,
      projectVersionId: projectId,
      userId: '',
      withdrawPerson: withdrawPerson,
      withdrawFirstPaidInd: isWithdrawFirst,
      isCOI: checkInterest,
    }

    // console.log('request', JSON.stringify(request))
    setRequest(request)

    if (formSchema?.attachmentGrantee) {
      let isValidateFile =
        formSchema?.attachmentGrantee?.attachFiles?.value.filter(
          (item) => !item.path && item.isRequired
        ) || []
      if (isValidateFile?.length === 0) {
        setShowConfirm(true)
        setIsGranteeFileError(false)
      } else {
        setIsGranteeFileError('กรุณาแนบไฟล์คุณสมบัติผู้รับทุนให้ครบถ้วน')
      }
    } else {
      setShowConfirm(true)
    }
  }

  const onSubmitChangeMainPerson = (data) => {
    console.log('data', data)
    console.log('attachFiles => ', formSchema.attachmentGrantee.attachFiles)
    console.log('signatoryList', signatoryList)

    let withdrawPerson = signatoryList.map((item, index) => {
      const honorificName = formSchema?.withdrawAuthorized?.honorific?.name + index
      const firstNameName = formSchema?.withdrawAuthorized?.firstName?.name + index
      const lastNameName = formSchema?.withdrawAuthorized?.lastName?.name + index

      return {
        ...item,
        honorific: data[honorificName] ?? item.honorific,
        firstName: data[firstNameName] ?? item.firstName,
        lastName: data[lastNameName] ?? item.lastName,
        isMainPerson: index === 0,
      }
    })

    let request = {
      projectVersionId: projectId,
      withdrawPerson: withdrawPerson,
    }

    const formData = new FormData()

    withdrawPerson &&
      withdrawPerson?.forEach((element, index) => {
        formData.append(`WithdrawPerson[${index}].honorific`, element.honorific)
        formData.append(`WithdrawPerson[${index}].firstName`, element.firstName)
        formData.append(`WithdrawPerson[${index}].lastName`, element.lastName)
        formData.append(`WithdrawPerson[${index}].isMainPerson`, element.isMainPerson)
      })
    data[schemaFile.name] &&
      data[schemaFile.name]?.forEach((element) => {
        formData.append('Files', element.blobFile)
      })
    formData.append('Remark', data[schemaRemark.name] || '')
    // formData.append('IsSendToGrantee', sendToGranteeVal || false)
    // formData.append('ApproveType', data[formSchema?.approveType?.name] || '')
    // formData.append('Id', id || '')
    formData.append('IsWithdrawFirst', isWithdrawFirst || '')
    formData.append('CheckInterest', checkInterest || '')
    formData.append('IsMakeContractAndChangeMainPerson', true)

    console.log('request', request)
    setRequest(formData)
    setShowConfirmChangeMainPerson(true)
  }

  const handleOnConfirm = () => {
    handleUpdateMakeContract(request)
  }

  const handlePlusMonth = () => {
    let arr = [...signatoryList]
    arr.push({ honorific: '', firstName: '', lastName: '' })
    setSignatoryList(arr)
  }

  const handleDeleteMonth = (index) => {
    let arr = [...signatoryList]
    // console.log('arr', arr, 'index', index)
    arr.splice(index, 1)
    setSignatoryList(arr)
  }

  const renderSignatory = signatoryList.map((item, index) => {
    return (
      <>
      <Row key={index}>
        <Col xs={24} sm={8} md={4} lg={4} style={{ marginTop: 35, width: 100 }}>
          {index == 0 ? 'ผู้ลงนามหลัก' : 'ผู้ลงนามร่วม'}
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(formSchema?.withdrawAuthorized?.honorific?.validators) && 'required'
            )}
          >
            {formSchema?.withdrawAuthorized?.honorific?.label}
          </ControlLabel>
          <ErrorMessage error={errors[formSchema?.withdrawAuthorized?.honorific?.name + index]} />
          <Controller
            name={formSchema?.withdrawAuthorized?.honorific?.name + index}
            control={control}
            defaultValue={item.honorific}
            rules={isValidators(formSchema?.withdrawAuthorized?.honorific?.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  data={formSchema?.withdrawAuthorized?.honorific?.options}
                  value={props.value}
                  style={{ width: '100%' }}
                  placeholder="เลือก"
                  disabled={!isChangeMainPerson && item.disable}
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                />
              )
            }}
          />
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(formSchema?.withdrawAuthorized?.firstName?.validators) && 'required'
            )}
          >
            {formSchema?.withdrawAuthorized?.firstName?.label}
          </ControlLabel>
          <ErrorMessage error={errors[formSchema?.withdrawAuthorized?.firstName?.name + index]} />
          <Controller
            key={formSchema?.withdrawAuthorized?.firstName?.name + index}
            name={formSchema?.withdrawAuthorized?.firstName?.name + index}
            control={control}
            rules={isValidators(formSchema?.withdrawAuthorized?.firstName?.validators)}
            defaultValue={item.firstName}
            render={(props) => {
              return (
                <Input
                  name={formSchema?.withdrawAuthorized?.firstName?.name + index}
                  value={props.value}
                  defaultValue={item.firstName}
                  placeholder={formSchema?.withdrawAuthorized?.firstName?.label}
                  onChange={(e) => {
                    props.onChange(e)
                  }}
                  disabled={!isChangeMainPerson && item.disable}
                />
              )
            }}
          />
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(formSchema?.withdrawAuthorized?.lastName?.validators) && 'required'
            )}
          >
            {formSchema?.withdrawAuthorized?.lastName?.label}
          </ControlLabel>
          <ErrorMessage error={errors[formSchema?.withdrawAuthorized?.lastName?.name + index]} />
          <Controller
            key={formSchema?.withdrawAuthorized?.lastName?.name + index}
            name={formSchema?.withdrawAuthorized?.lastName?.name + index}
            control={control}
            rules={isValidators(formSchema?.withdrawAuthorized?.lastName?.validators)}
            defaultValue={item.lastName}
            render={(props) => {
              return (
                <Input
                  name={formSchema?.withdrawAuthorized?.lastName?.name + index}
                  value={props.value}
                  defaultValue={item.lastName}
                  placeholder={formSchema?.withdrawAuthorized?.lastName?.label}
                  onChange={(e) => {
                    props.onChange(e)
                  }}
                  disabled={!isChangeMainPerson && item.disable}
                />
              )
            }}
          />
        </Col>

        {index >= withdrawAuthorizedRequest && (
          <Col xs={4} sm={4} md={3} lg={3} style={{ marginTop: 32, width: 50 }}>
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-cancel"
              icon={<Icon appearance="ghost" icon="trash" className="bt-gost-icon-radius-cancel" />}
              onClick={() => handleDeleteMonth(index)}
              style={{ marginLeft: 5 }}
            ></IconButton>
          </Col>
        )}

        {signatoryList.length - 1 === index && (
          <Col xs={3} sm={3} md={3} lg={3} style={{ marginTop: 32, width: 50 }}>
            <IconButton
              appearance="ghost"
              icon={<Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />}
              onClick={() => handlePlusMonth()}
            >
              เพิ่มผู้ลงนามร่วม
            </IconButton>
          </Col>
        )}
      </Row>
      {index == 0 && <Row>
        <Col xs={4} sm={4} md={4} lg={4} style={{ marginTop: 35, width: 100 }}>
        </Col>
        <Col xs={20} sm={20} md={20} lg={20} style={{ marginTop: 0}}>
            <Checkbox
              checked={isChangeMainPerson}
              onChange={(value, checked) => {
                if(!checked) {
                  var mainPersonOriginal
                  props?.schema?.withdrawAuthorized?.values?.forEach((item, index) => {
                    if (item.isMainPerson) {
                      mainPersonOriginal = item
                    }
                  })

                  console.log('mainPersonOriginal', mainPersonOriginal)

                  setValue(formSchema?.withdrawAuthorized?.honorific?.name + 0, mainPersonOriginal.honorific)
                  setValue(formSchema?.withdrawAuthorized?.firstName?.name + 0, mainPersonOriginal.firstName)
                  setValue(formSchema?.withdrawAuthorized?.lastName?.name + 0, mainPersonOriginal.lastName)
                }
                setIsChangeMainPerson(checked)
              }}
            >
              ขอแก้ไขผู้ลงนามหลัก
            </Checkbox>
          </Col>
      </Row>}
      </>
    )
  })

  const handleChangeGetBankBranch = async (bankCode) => {
    console.log('handleChangeGetBankBranch => ', bankCode)
    setIsLoading(true)
    startLoading()
    try {
      const response = await getBankAccount(projectId, bankCode)
      // console.log('response => ', response.model)
      // console.log('bankAccountSchema => ', bankAccountSchema)
      setFormBankAccountSchema(response.model.forms)
      // setFormSchema(response.model.forms)
      // setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel header={formSchema.panelText} bordered collapsible defaultExpanded shaded>
        {formSchema?.attachment && (
          <>
            {/* <span>{formSchema.attachment.header}</span> */}
            {/* {isContartFileError && (
              <Row style={{ marginBottom: 10 }}>
                <Message showIcon type="error" description={`${isContartFileError}ไม่สำเร็จ`} />
              </Row>
            )}
            <AttachFilesView
              schema={formSchema.attachment.attachFiles}
              onDownload={onDownloadContractAndProposalFile}
              onPreview={onPreviewContractAndProposalFile}
            /> */}

            {errorSchemaFileAll && (
              <Message showIcon type="error" description={errorSchemaFileAll} />
            )}
            {schemaFileAll?.forms?.contract && (
              <>
                <AttachFilesDocWidget
                  schema={schemaFileAll.forms.contract}
                  shaded={false}
                  header={'ไฟล์ประกอบการทำสัญญา'}
                />
                <br />
              </>
            )}
          </>
        )}

        {/* {isAddAtttachmentsOnly && (
          <div>
            {isOpenBankPdfError ? (
              <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
            ) : (
              <PdfRenderWidgets
                header={'หนังสือขอเปิดบัญชีเงินฝากธนาคาร'}
                file={previewOpenBankPdf}
                isLoading={isLoadingOpenBankPDF}
                fileName={'หนังสือขอเปิดบัญชีเงินฝากธนาคาร'}
                onReload={() => {
                  handleGetOpenBankFile(projectId)
                }}
                loadingMessage={
                  'กรุณารอสักครู่ ระบบกำลังสร้าง PDF หนังสือขอเปิดบัญชีเงินฝากธนาคาร...'
                }
                firstExpandToReload={true}
              />
            )}
          </div>
        )} */}

        <br />

        {formSchema?.attachmentGrantee && (
          <div>
            <span>{formSchema.attachmentGrantee.header}</span>
            {isGranteeFileError && (
              <Row style={{ marginBottom: 10 }}>
                <Message showIcon type="error" description={`${isGranteeFileError}`} />
              </Row>
            )}
            <AttachFilesGranteeContract
              schema={formSchema.attachmentGrantee}
              // onSubmit={onUpload}
              onDelete={onDelete}
              // onUpdate={onUpdate}
              onDownload={onDownload}
              onPreview={onPreview}
              onUploadSuccess={(e) => handleOnUploadSuccess(e)}
              onUploadError={(e) =>
                setIsGranteeFileError(e.response.errorMessage + ' อัพโหลดไม่สำเร็จ')
              }
              isEditErr={isEditErr}
              isUploadErr={isUploadErr}
              isDeleteError={isDeleteError}
              loading={isLoading}
              isContract={true}
            />
          </div>
        )}

        {requestDocText && <Message showIcon type="warning" description={requestDocText} />}

        <br />

        {formSchema?.withdrawAuthorized && (
          <>
            <span className="required">{formSchema.withdrawAuthorized.header}</span>
            <Message
              showIcon
              type="warning"
              description={
                'ห้ามระบุเจ้าหน้าที่การเงินของโครงการเป็นผู้มีอำนาจสั่งจ่ายเงินจากบัญชีรับเงินสนับสนุนโครงการ'
              }
            />
            <Message
              showIcon
              type="warning"
              description={
                'กรุณาตรวจสอบ คำนำหน้า ชื่อ-นามสกุล ให้ถูกต้องตรงกับบัตรประจำตัวประชาชน'
              }
            />
            <Row>
              {signatoryList.length > 0 && renderSignatory}

              {signatoryList.length === 0 && (
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 34, width: 50 }}>
                  <IconButton
                    appearance="ghost"
                    icon={<Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />}
                    onClick={() => handlePlusMonth()}
                  >
                    เพิ่มผู้ลงนามหลัก
                  </IconButton>
                </Col>
              )}
            </Row>
            <br />
          </>
        )}

        {isChangeMainPerson && (
          <>
            {showCommandButton ? (
              <Row>
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: '10px' }}>
                  <ControlLabel
                    className={classNames(isRequired(schemaFile.validators) && 'required')}
                  >
                    {schemaFile.label}
                  </ControlLabel>
                  <ErrorMessage error={errors.refFile} />
                  <Controller
                    name={schemaFile.name}
                    control={control}
                    rules={schemaFile.value.length == 0 && isValidators(schemaFile.validators)}
                    render={(props) => {
                      return (
                        <Uploader
                          draggable
                          autoUpload={false}
                          multiple={false}
                          fileList={props.value || []}
                          onChange={(fileList) => {
                            if (isEmpty(fileList)) {
                              props.onChange(undefined)
                            } else {
                              let files = []
                              files.push(fileList[fileList.length - 1])
                              props.onChange(files)
                            }
                          }}
                        >
                          <div>
                            <div
                              style={{ lineHeight: '50px' }}
                              className={classNames('uploader', `${theme[0]}-background`)}
                            >
                              <Icon size="4x" icon="upload2" />
                              <small className="uploder__text">
                                <p style={{ wordBreak: 'break-word' }}>
                                  คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                                </p>
                              </small>
                            </div>
                          </div>
                        </Uploader>
                      )
                    }}
                  />
                </Col>
              </Row>
            ) : (
              <>
                {/* <span>{schemaFile.label}</span>
                <AttachFilesMakeContractView
                  schema={getRefFileViewSchema()}
                  onDownload={onDownload}
                  onPreview={onPreview}
                /> */}
              </>
            )}

            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <InputForm
                  schema={schemaRemark}
                  rows={4}
                  componentClass="textarea"
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            </Row>
          </>
        )}

        {isAddAtttachmentsOnly && (
          <>
            <span className="required">{formBankAccountSchema.header}</span>
            <CenterAddBankAccountForm
              schema={formBankAccountSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              changeGetBankBranch={handleChangeGetBankBranch}
            />
          </>
        )}

        <Checkbox
          onChange={(value, checked) => setIsWithdrawFirst(checked)}
          checked={isWithdrawFirst}
        >
          {'ขอเบิกงวดที่ 1 พร้อมทำสัญญา'}
        </Checkbox>

        <Checkbox
          onChange={(value, checked) => {
            setIsShareholdersCoi(checked)
          }}
        >
          มีการเปลี่ยนแปลงกรรมการ/หุ้นส่วน/ผู้ถือหุ้น
        </Checkbox>

        {isShareholdersCoi && (
          <div style={{ marginBottom: 30, marginTop: 30 }}>
            <COIValidateWidget
              disabled={!showCommandButton}
              isCOIPass={isCOIPass}
              setIsCOIPass={setIsCOIPass}
              checkCOI={checkCOI}
              setCheckCOI={setCheckCOI}
              setIsCheckCOI={setIsCheckCOI}
              setCheckInterest={setCheckInterest}
              checkInterest={checkInterest}
              fixType={'9'}
            />
          </div>
        )}

        {showCommandButton && <hr />}

        {isMakeContractError && (
          <Message showIcon type="error" description={formSchema.buttonText + `ไม่สำเร็จ`} />
        )}

        {showCommandButton && (
          isChangeMainPerson ?
          <IconButton
            appearance="ghost"
            icon={<Icon icon="send" className="bt-gost-icon-radius"></Icon>}
            onClick={handleSubmit(onSubmitChangeMainPerson)}
            disabled={isShareholdersCoi && (!isCOIPass || (!checkCOI && !checkInterest))}
          >
            {"ขออนุมัติแก้ไขผู้มีอำนาจลงนามเบิกจ่าย และยืนยันทำสัญญา/ข้อตกลง"}
          </IconButton>
          :
          <IconButton
            appearance="ghost"
            icon={<Icon icon="check" className="bt-gost-icon-radius"></Icon>}
            onClick={handleSubmit(onSubmit)}
            disabled={isShareholdersCoi && (!isCOIPass || (!checkCOI && !checkInterest))}
          >
            {formSchema.buttonText}
          </IconButton>
        )}

        <ConfirmWidget
          title={`ยืนยันการ${formSchema.buttonText}`}
          show={showConfirm}
          detail={`ท่านต้องการ${formSchema.buttonText}ใช่หรือไม่ ?`}
          onCancle={() => setShowConfirm(false)}
          onConfirm={() => handleOnConfirm()}
        />

        <ConfirmWidget
          title={`ยืนยันการขออนุมัติแก้ไขผู้มีอำนาจลงนามเบิกจ่าย และยืนยันทำสัญญา/ข้อตกลง`}
          show={showConfirmChangeMainPerson}
          detail={`ท่านต้องการขออนุมัติแก้ไขผู้มีอำนาจลงนามเบิกจ่าย และยืนยันทำสัญญา/ข้อตกลงใช่หรือไม่ ?`}
          onCancle={() => setShowConfirmChangeMainPerson(false)}
          onConfirm={() => handleUpdateMakeContractAndChangeMainPerson(request)}
        />
      </Panel>

      {!requestDocText && formSchema.filepdf && (
        <>
          {isPdfError ? (
            <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
          ) : (
            <PdfRenderWidgets
              file={previewPdf}
              isLoading={isLoadingPDF}
              header={'สัญญา'}
              fileName={'สัญญา'}
              onReload={() => handleGetDownloadContractPdf(formSchema.filepdf.fileName)}
              loadingMessage={'กรุณารอสักครู่ ระบบกำลังสร้าง PDF สัญญา...'}
              firstExpandToReload={isAddAtttachmentsOnly}
            />
          )}
          <br />{' '}
        </>
      )}
    </>
  )
}
const schemaRemark = {
    "name": "remark",
    "label": "เหตุผลการขอแก้ไข",
    "value": "",
    "validators": [
        {
            "type": "REQUIRED",
            "value": null,
            "errorMessage": "กรุณาระบุข้อความ"
        },
        {
            "type": "MAXLENGTH",
            "value": 1000,
            "errorMessage": "ข้อความเกิน 1000 อักขระ"
        }
    ]
}

const schemaFile = {
    "name": "refFile",
    "label": "แนบไฟล์หนังสือขอเปลี่ยนแปลงผู้มีอำนาจลงนามเปิดบัญชี และเบิกจ่าย",
    "value": [],
    "validators": [
        {
            "type": "REQUIRED",
            "value": null,
            "errorMessage": "กรุณาแนบไฟล์หนังสือขอเปลี่ยนแปลงผู้มีอำนาจลงนามเปิดบัญชี และเบิกจ่าย"
        }
    ]
}

const bookBank = {
  header: 'บัญชีเงินฝากธนาคารสำหรับเบิกจ่าย',
  buttonText: 'บันทึกบัญชีเงินฝากธนาคารสำหรับเบิกจ่าย',
  bankName: {
    name: 'bankName',
    label: 'ชื่อธนาคาร',
    value: 'กรุงไทย',
    disabled: true,
    validators: [
      {
        type: 'REQUIRED',
        value: null,
        errorMessage: 'กรุณากรอกชื่อธนาคาร',
      },
    ],
  },
  bankBranch: {
    name: 'bankBranch',
    label: 'สาขา',
    value: 'รัชดา',
    disabled: true,
    validators: [
      {
        type: 'REQUIRED',
        value: null,
        errorMessage: 'กรุณากรอกสาขา',
      },
    ],
  },
  bankAccountNumber: {
    name: 'bankAccountNumber',
    label: 'เลขที่บัญชี',
    value: '1234567890',
    disabled: true,
    validators: [
      {
        type: 'REQUIRED',
        value: null,
        errorMessage: 'กรุณากรอกเลขที่บัญชี',
      },
    ],
  },
}
